import { RouteFactory } from "@app/routePaths";
import { AdvertisementTypeEnum } from "@app/types/enums";
import garageLogo from "@assets/verticals/garage-logo-black.svg";
import WinIfraLogo from "@assets/verticals/garage-win-infra.png";
import Advertisement from "@components/Advertisement/Advertisement";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function GarageBanner(): React.ReactElement {
  return (
    <>
      <SectionMasthead
        link={RouteFactory.garage}
        masthead={{
          alt: "Garage logo",
          src: garageLogo,
          width: 111,
          height: 40,
        }}
      />

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex flex-row items-center gap-x-4">
          <img src={WinIfraLogo} alt="UOB logo" width="62" height="46" />

          <span className="font-poppins text-base font-light">
            BEST DIGITAL NEWS START-UP, WAN-IFRA 2019 GOLD AWARD
          </span>
        </div>
      </Banner>

      <Advertisement
        rootClassName="pb-6"
        adUnitProps={{
          slot: GoogleAdsSlotFactory.lb1(RouteFactory.garage.replace("/", "")),
          type: AdvertisementTypeEnum.LB1,
        }}
      />
    </>
  );
}
